module.exports = "\r\n<div class=\"container\">\r\n  <div class=\"separator\"></div>\r\n  <blockquote class=\"quote\">\r\n    <i class=\"fa fa-quote-left fa-pull-left fa-2x\" aria-hidden=\"true\"></i>\r\n    {{quote}}\r\n    <i class=\"fa fa-quote-right fa-pull-right fa-2x\" aria-hidden=\"true\"></i>\r\n  </blockquote>\r\n  <p class=\"author\">{{author}}</p>\r\n  <div class=\"separator\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/quote/quote.component.html
// module id = 790
// module chunks = 1